export const SITE = {
  name: "Desire Vet Care Pvt. Ltd.",
  shortName: "Desire Vet Care",
  tagline: "A Fullfill Desire of Animal Health Care",
  domain: "www.desirevetcare.com",
  email: "Info.desirevetcare@gmail.com",
  phoneDisplay: "+91 70230 42767",
  phoneRaw: "917023042767",
  address: "Delhi",
  whatsappBase: "https://wa.me/917023042767",
  mapsEmbed:
    "https://www.google.com/maps?q=Joshi+Road,Karol+Bagh,New+Delhi&output=embed",
  social: {
    facebook: "https://www.facebook.com/share/1924WHLTT2/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/desirevetcare/",
    whatsapp: "https://wa.me/917023042767",
  },
};

export const waLink = (text) =>
  `${SITE.whatsappBase}?text=${encodeURIComponent(text || "Hello Desire Vet Care, I have an inquiry about your products.")}`;
